export default __webpack_public_path__ + "static/media/330_dummy2016-streetfashion01-de.cd27db38.png";